import axios from "axios";
import Swal from "sweetalert2";

export const getPaymentMethods = async () => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        "/v1/admin/paymentmethods",
        {headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };
    

  export const postPaymentMethods = async (postData) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        "/v1/admin/paymentmethods",postData,
        {headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

  export const updatePaymentMethod = async (postData, id) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        `/v1/admin/paymentmethods/${id}`, postData,   
        {headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        "Accept-language":lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

  export const showPaymentMethod = async (id, lang) => {
    try {
      const brear = localStorage.getItem("token");
      const { data } = await axios.get(
        `/v1/admin/paymentmethods/${id}`,    
        {
          
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        "Accept-language":lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

 

  export const deletePaymentMethod = async (id,lang) => {
  const brear = localStorage.getItem("token");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.delete(`/v1/admin/paymentmethods/${id}`, { headers:{
               Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        AcceptLanguage: lang,
      }
 
      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;    
    } catch (error) {
      throw error;
    }
  }
};